<template>
  <div class="news-wrap">
    <div>
      <div class="banner">
        <img src="@/assets/imgs/introduction.png" alt />
      </div>
      <div class="newsbox">
        <div class="clearfix wrap" style="padding-top: 60px; padding-bottom: 60px">
          <div class="menutitle">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>美术馆简介></el-breadcrumb-item>
            </el-breadcrumb>
            <div class="introduction_box">
              <div class="introduction_container">上饶美术馆是一座以收藏、研究、推广、展示近现代及当代艺术家作品为重点，并致力于审美教育与国际间文化交流的综合造型艺术博物馆。天津美术馆总建筑面积为 28065 平方米建筑层数为5层，建筑高度为 29.70米。术家作品为重点，并致力于审美教育与国际间文化交流的综合造型艺术博物馆。天津美术馆总建筑面积为 28065平方米、建筑层数为5层，建筑高度为 29.70 米。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rigthBox from "@/components/rigthBox";
export default {
  components: {
    rigthBox
  },
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 5
      },
      nextFlag: true,
      finalFlag: false,
      tipMessage: "努力加载中...",
      sidebarTitle: "陈列展览",
      rigthBoxData: [
        {
          name: "正在展览",
          index: "menu1",
          path: "/nowplay",
          children: []
        },
        {
          name: "展览预告",
          index: "menu2",
          path: "/displayYugao",
          children: []
        },
        {
          name: "展览回顾",
          index: "menu3",
          path: "/displayreview",
          children: []
        }
      ],
      informationData: [],
      arr: [],
      imgArr: [],
      type: "2"
    };
  },
  async mounted() {
    var that = this;
    // await that.$axios
    //   .get('/frontapi/expo/main/list?pageNum=1&pageSize=5&'+'params[type]='+that.type)

    //  await this.$axios({
    //   method: "get",
    //   url: "/frontapi/expo/main/list",
    //       params:
    //       {  pageNum:1,
    //          pageSize:5,
    //          'params[type]':that.type},
    //          data: {},
    //       })
    // .then(function (res) {
    //   console.log(res.data, "123");
    //   if (res.data.code != 500) {
    //     that.informationData = res.data.rows;
    //     that.arr = res.data.rows
    //       .map((item) => {
    //         return item.imgId;
    //       })
    //       .join();
    //   }
    // });
    await this.getList();
    await that.$axios.get(`/common/fileInfo/${that.arr}`).then(res => {
      this.imgArr = res.data.data.map(item => {
        return that.$axios.defaults.baseURL + item.filePath;
      });
      this.imgArr = this.imgArr.reverse();
    });
  },
  methods: {
    go(val) {
      this.$router.push({ path: "/displayDetail", query: { id: val.id } });
    },
    handleScroll(event) {
      let Scroll = event.target;
      console.log(Scroll.scrollHeight, "kkkkkkkkkkkkkkkkk");
      //滚动条到底部的条件
      if (
        Scroll.scrollHeight - (Scroll.scrollTop + Scroll.clientHeight) > 10 &&
        !this.nextFlag &&
        !this.finalFlag
      ) {
        console.log(123232323);
        this.nextFlag = true;
        this.page.pageNum++;
        setTimeout(() => {
          this.getList();
        }, 1000);
      }
    },
    async getList() {
      var that = this;
      await this.$axios({
        method: "get",
        url: "/frontapi/expo/main/list",
        params: {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          "params[type]": 2
        },
        data: {}
      }).then(
        function(res) {
          console.log(res);
          let length = res.data.rows.length;
          for (let i = 0; i < length; i++) {
            let bgImg = res.data.rows[i].params.reallyFilePath;
            console.log(bgImg, "bgImg1");
            if (bgImg.indexOf(",") != -1) {
              let s = bgImg.split(",");
              //bgImg = axios.defaults.baseURL +s[0];
              res.data.rows[i].firstImg = that.$axios.defaults.baseURL + s[0];
              res.data.rows[i].secondImg = that.$axios.defaults.baseURL + s[1];
            } else {
              res.data.rows[i].secondImg = that.$axios.defaults.baseURL + bgImg;
            }
          }
          that.informationData = [...that.informationData, ...res.data.rows];
          console.log(that.informationData + " that.informationData");
          if (res.data.rows.length == 0) {
            that.tipMessage = "数据已加载完!";
            that.finalFlag = true;
          }
          that.nextFlag = false;
          that.arr = res.data.rows
            .map(item => {
              return item.imgId;
            })
            .join();
        },
        function() {
          // console.log("请求失败");
        }
      );
    }
  }
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
  font-size: 18px;
}
img {
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
}

.news-wrap {
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
  width: 100%;
  background-color: #f4f4f4;
}
.wrap {
  margin: 0 auto;
  width: 1200px;
  background: #f4f4f4;
}
.banner {
  height: auto;
  width: 100%;
}
.banner > img {
  height: 100%;
  width: 100%;
}
.newsbox {
  background: #f4f4f4;
}
.clearfix:after {
  display: block;
  content: "";
  overflow: hidden;
  clear: both;
  height: 0;
}
.news-wrap >>> .menutitle {
  cursor: pointer;
}
.news-wrap >>> .is-link {
  font-weight: 400;
  color: #606266;
  cursor: pointer;
}
.menutitle >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.newscontent {
  width: 860px;
  height: 990px;
  background: #ffffff;
  float: left;
  margin-top: 40px;
  border-radius: 10px;
  overflow: scroll;
}
.newscontent::-webkit-scrollbar {
  display: none;
}
.newslist {
  width: 100%;
  height: auto;
  padding: 0 30px;
}
.newslist li {
  /* padding: 30px; */
  height: 320px;
  padding-top: 30px;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
}
.newslist img {
  float: left;
  width: 200px;
  height: 260px;
}
.newslist .newstit {
  float: left;
  padding-left: 23px;
  height: 260px;
  width: 553px;
}
.newstit h3 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 25px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
}
.newstit h3 a {
  color: #222222;
}
.newstit > span {
  display: block;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  line-height: 54px;
}
.newstit > p {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 20px;
}
.newstit h4 {
  width: 100%;
  height: 100px;
  margin-top: 8px;
  font-size: 14px;
  line-height: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.load-text {
  margin-left: 10px;
  font-size: 14px;
}
.load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.load-text {
  margin-left: 10px;
  font-size: 14px;
}
.introduction_box{
    width: 100%;
    margin: auto;
    margin-top: 20px;
}
.introduction_container{
    font-size: 15px;
    line-height: 25px;
    text-indent: 22px;
    padding: 28px;
    background: #fff;
    border-radius: 15px;
    height: 300px;
    font-weight: bold;
}
</style>
